import { useEffect, useState } from "react";
import bookingApi from "../../api/booking/booking";
import trainerApi from "../../api/trainer/trainer";
import usersApi from "../../api/user/user";
import { useLocation } from "react-router-dom";
import { ui } from "../../helpers/ui";

const InitTrainingsLogic = () => {
  const locationUrl = useLocation();

  // state postoji samo kad se dodje sa Home ekrana - direktan ulazak
  // (obeleživač, novi tab) je ranije obarao stranicu, sad se korisnik
  // dovuče sa servera
  const [user, setUser] = useState<any>(locationUrl.state?.user);

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [trainings, setTrainings] = useState<any[]>([]);
  const [trainers, setTrainers] = useState<any[]>([]);

  const [location, setLocation] = useState<string>("Centar");

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const locations = ["Centar", "Radnička"];

  useEffect(() => {
    loadTrainings();
    trainerApi
      .getTrainers()
      .then((response) => {
        if (response.status === 200) setTrainers(response.data);
      })
      .catch(() => {
        // Lista trenera nije kritična za prikaz grupa
      });
    if (!locationUrl.state?.user) {
      usersApi
        .getMe()
        .then((response) => {
          if (response.status === 200) setUser(response.data);
        })
        .catch(() => {
          // Bez korisnika se samo ne prikazuju admin dugmad
        });
    }
  }, []);

  useEffect(() => {
    loadTrainings();
  }, [location]);

  // silent = osveži podatke bez skidanja celog ekrana na spinner (npr. posle
  // promene trenera - kalendar bi se resetovao na tekući mesec)
  const loadTrainings = (silent: boolean = false) => {
    if (!silent) setIsLoading(true);
    bookingApi
      .getBookings(location)
      .then((response) => {
        if (response.status === 200) {
          const sortedData = response.data.sort(
            (a: any, b: any) =>
              new Date(a.date).getTime() - new Date(b.date).getTime()
          );
          setTrainings(sortedData);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onBook = (data: any) => {
    bookingApi
      .trainerBook(data)
      .then(() => {
        loadTrainings();
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onCancel = (id: number, expectedClients?: number) => {
    bookingApi
      .trainerCancel({ id, expectedClients })
      .then(() => {
        loadTrainings();
      })
      .catch((e) => {
        // Npr. neko se zakazao u međuvremenu - povuci sveže podatke
        loadTrainings(true);
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChangeLocation = (event: any) => {
    setTrainings([]);
    setLocation(event.target.value);
    setSelectedDate(null);
  };

  const onSetTrainer = (bookingId: number, trainerId: number | null) => {
    bookingApi
      .setTrainer(bookingId, trainerId)
      .then(() => {
        loadTrainings(true);
      })
      .catch((e) => {
        loadTrainings(true);
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const showClientsFromBooking = (booking: any) => {
    const lines = booking.clients.map((client: any) => {
      const isNew =
        (!client.payments || client.payments.length === 0) &&
        (!client.trainings || client.trainings.length === 0);
      const tag = client.trial
        ? " (Probni)"
        : isNew
          ? " (Novi klijent)"
          : "";
      return `${client.firstName} ${client.lastName}${tag}`;
    });

    const hasTrialOrNew = booking.clients.some(
      (client: any) =>
        client.trial ||
        ((!client.payments || client.payments.length === 0) &&
          (!client.trainings || client.trainings.length === 0)),
    );

    // Trener se ne prikazuje - vec se vidi u selectu na kartici termina
    let message = lines.join("\n");
    if (hasTrialOrNew) {
      // Podebljan je samo naslov napomene (** oznake razume alert modal)
      message +=
        "\n\n**Napomena za trenere:** klijentu označenom kao Probni ili Novi klijent treba pokazati studio i sve objasniti. Razlika: Probni ne plaća trening, a Novi klijent plaća trening.";
    }
    ui.alert(message);
  };

  return {
    user,
    selectedDate,
    trainings,
    trainers,
    locations,
    isLoading,
    setSelectedDate,
    onBook,
    onCancel,
    onChangeLocation,
    onSetTrainer,
    showClientsFromBooking,
  };
};

export default InitTrainingsLogic;
